import { Button as UIButton, type ButtonProps as UIButtonProps } from '@ui'
import React, { FC } from 'react'

type LegacyVariant = 'rainbow' | 'contained' | 'outlined' | 'text' | 'link' | 'destroy'

interface Props extends Omit<UIButtonProps, 'variant' | 'size'> {
  variant?: LegacyVariant
  size?: 'small' | 'medium' | 'large'
}

const VARIANTS: Record<LegacyVariant, UIButtonProps['variant']> = {
  rainbow: 'primary',
  contained: 'secondary',
  outlined: 'secondary',
  text: 'ghost',
  link: 'link',
  destroy: 'danger',
}

const SIZES = { small: 'sm', medium: 'md', large: 'lg' } as const

/**
 * Legacy-API shim over the @ui Button, kept MUI-free. New code imports `Button` from `@ui`.
 * Kept because the "Review deposit" button in Earn/Components/EarnDeposit.tsx must keep its exact props.
 */
const Button: FC<Props> = ({ variant = 'text', size = 'medium', ...props }) => (
  <UIButton variant={VARIANTS[variant]} size={SIZES[size]} {...props} />
)

export default Button
